export const TYPE_SUCESS = 'sucess';
export const TYPE_ERROR = 'error';

export function playSound(type) {
  const sounds = {
    success: new Audio("/sounds/success.mp3"),
    error: new Audio("/sounds/error.mp3"),
  };
  sounds[type].play();
}